import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CompanyCard from "../explore_companies/CompanyCard";
import http from "../../../helpers/http";
import { doObjToFormData } from "../../../helpers/helpers";
import { getAuthUserToken } from "../../../helpers/authToken";
import LoaderSpinner from "../../common/LoaderSpinner";
import useDocumentTitle from "../../../hooks/useDocumentTitle";

/**
 * The shortlist.
 *
 * Same card as the directory, so a saved employer looks exactly like the one
 * it was saved from - including the employers we know only from the Home
 * Office file, which have no record of ours behind them.
 *
 * Unsaving removes the row here immediately rather than leaving a card the
 * member has just told us they do not want.
 */
export default function SavedCompanies() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  useDocumentTitle("Saved companies");

  useEffect(() => {
    let live = true;
    http
      .post(
        "user/saved-companies",
        doObjToFormData({ token: getAuthUserToken() }),
      )
      .then(({ data }) => {
        if (!live) return;
        setRows(Array.isArray(data?.companies) ? data.companies : []);
        setLoading(false);
      })
      .catch(() => live && setLoading(false));
    return () => {
      live = false;
    };
  }, []);

  const drop = (name) =>
    setRows((list) => list.filter((c) => c.name !== name));

  return (
    <section id="find_jobs">
      <div className="contain">
        <div className="top_text">
          <h2>Saved companies</h2>
          <p>
            Employers you have shortlisted, with what they sponsored in 2025.
          </p>
          {/* A way back whether or not the list has anything in it - the
              empty state had one, a full list did not, which left the page a
              dead end for exactly the people using it. */}
          <div className="btn_blk">
            <Link to="/explore-companies/1" className="site_btn">
              Browse all companies
            </Link>
          </div>
        </div>

        {loading ? (
          <div className="text-center">
            <LoaderSpinner />
          </div>
        ) : rows.length === 0 ? (
          <div className="msg_no_jobs">
            <p>
              <strong>You have not saved any companies yet.</strong> Use the
              bookmark on any company to keep it here.
            </p>
            <div className="btn_blk">
              <Link to="/explore-companies/1" className="site_btn">
                Explore companies
              </Link>
            </div>
          </div>
        ) : (
          <div className="all_companies_wrapper">
            <div className="row form_row">
              {rows.map((c, i) => (
                <div
                  className="col-md-6 d-flex"
                  key={`${c.name}-${i}`}
                >
                  <CompanyCard company={c} onUnsave={drop} />
                </div>
              ))}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
